import { defineMessages } from 'react-intl';

export default defineMessages({
  placeholder: {
    id: 'components.atom.datepicker.placeholder',
    defaultMessage: 'DD/MM/YYYY',
  },
});
